import TreasuryApi from "./treasuryApi";
import {
  getMovementTypeLabel,
  MOVEMENT_TYPE_OPTIONS,
} from "./treasuryOptions";
import TreasuryCrudPanel from "./TreasuryCrudPanel";

export default function TreasuryMovementCategoriesPanel() {
  return (
    <TreasuryCrudPanel
      title="Categorías de movimientos"
      description="Administrá las categorías disponibles para nuevos movimientos de tesorería."
      entityLabel="Categoría"
      pluralLabel="las categorías"
      emptyMessage="No hay categorías cargadas."
      typeLabel="Tipo de movimiento"
      typeField="movement_type"
      typeOptions={MOVEMENT_TYPE_OPTIONS}
      list={TreasuryApi.listMovementCategories}
      create={TreasuryApi.createMovementCategory}
      update={TreasuryApi.updateMovementCategory}
      remove={TreasuryApi.deleteMovementCategory}
      getTypeLabel={getMovementTypeLabel}
    />
  );
}
